
import { catchError, map, tap } from 'rxjs/operators';
// https://ryanchenkie.com/angular-authentication-using-the-http-client-and-http-interceptors

import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { Observable, throwError } from 'rxjs';
import { DebugService as debug } from "@core/services/debug.service";
import { JWTTokens, LocalStorageKeys } from './auth/auth.service';
import { AuthService } from '@core/services/auth/auth.service';

const API_KEY: string = environment.API_KEY;
const API_URL: string = environment.APP_URL;
const IS_PROD: boolean = environment.production;


@Injectable()
export class HttpResponseInterceptor implements HttpInterceptor {

    constructor(
        private _auth: AuthService,
    ) { }


    /**
     * HTTP Interceptor
     * 
     * @param {HttpRequest<any>} req 
     * @param {HttpHandler} next 
     * @returns {Observable<HttpEvent<any>>} 
     * @memberof HttpResponseInterceptor
     */

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // if this is an non-CWC api call send it as is
        if (req.url.indexOf('http') == 0) {
            return next.handle(req);
        } else {


            // Modify the request with the necessary headers and api url for the CWC api
            let updatedReq = this._prepareRequest(req);

            return next.handle(updatedReq).pipe(
                tap((event) => {
                    if (event.type === HttpEventType.Response) {
                        //Log successful responses
                    }
                }),
                catchError(error => {

                    //Log failed responses

                    switch (error.status) {
                        case 401:
                            this._auth.reset();
                            break
                        default:
                            break
                    }
                    return throwError(() => error);
                })
            )

        }



    }

    // PREPARE HTTP HEADERS and API URL
    private _prepareRequest(req: HttpRequest<any>): HttpRequest<any> {

        //Load the tokens from local storage
        const rawTokens = localStorage.getItem(LocalStorageKeys.Tokens)
        let tokens: JWTTokens = "string" === typeof rawTokens ? JSON.parse(rawTokens) : {}

        //Prepare the data
        let authData = {
            key: API_KEY,
            url: window.location.href.includes("localhost:4200") ? undefined : window.location.href,
            token: tokens?.idToken
        };

        //Encode to base64 for transmission
        let authHeader: string = btoa(JSON.stringify(authData));

        let newReq = req.clone({
            setHeaders: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': authHeader
            },
            url: API_URL + req.url,
            body: JSON.stringify(req.body)
        });

        return newReq;
    }

}